import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RouterService {
  private readonly _route = new BehaviorSubject<string | null>(null);
  private readonly _navigationStack: string[];

  constructor() {
    this._navigationStack = [];
  }

  public get route$() {
    return this._route.asObservable();
  }

  public get route() {
    return this._route.value;
  }

  public navigate(route: string): void {
    this._route.next(route);
    this._navigationStack.push(route);
  }

  public back() {
    this._navigationStack.pop();
    const nextRoute = this._navigationStack[this._navigationStack.length - 1];
    if (!nextRoute) return;
    this._route.next(nextRoute);
  }
}
